import { useForm } from 'react-hook-form';
import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import { useEffect } from 'react';
import { ModalTheme } from '../../../../components/modal';
import { ButtonTheme } from '../../../../components/buttons';
import { RenderForm } from '../../../../components/forms';
import { FORM_CHANGE_BOOKING_DATE } from '../../forms/form';
import { useUpdateBooking } from '../../hooks/useUpdateBooking';
import { LoadingPage } from '../../../../components/loading';
import { useGetReasonChangeBookingDate } from '../../hooks/useGetStatus';

export const ChangeBookingDateModal = ({ open, onToggle, item }) => {
  const warrantyCode = item && item?.warrantyCode ? item?.warrantyCode : '-';
  const claimCode = item && item?.claimCode ? item?.claimCode : '-';
  const storeName = item && item?.storeName ? item?.storeName : '-';
  const storePhoneNumber = item && item?.storePhoneNumber ? item?.storePhoneNumber : '-';
  const expireDate = item && item?.expireDate ? item?.expireDate : '-';
  const bookingDate = dayjs().add(2, 'day').startOf('day').format('DD/MM/YYYY');
  const { control, setValue, getValues, handleSubmit, watch } = useForm({
    defaultValues: {
      warrantyCode,
      claimCode,
      storeName,
      storePhoneNumber,
      bookingDate,
      expireDate,
    },
  });
  const { optionsReasonChangeBookingDate, onFetchOptionsReasonChangeBookingDate } = useGetReasonChangeBookingDate();
  useEffect(() => {
    onFetchOptionsReasonChangeBookingDate();
  }, []);

  const { updateBooking, loading } = useUpdateBooking({
    onSuccessCallBack: () => {
      window.location.reload();
    },
  });


  function onSubmitSuccess() {
    const values = getValues();
    Swal.fire({
      icon: 'question',
      title: 'ยืนยันจองวันใหม่',
      text: `คุณต้องการเปลี่ยนวันเข้ารับสินค้าเคลมจาก ${bookingDate} เป็น ${values.bookingDate} หรือไม่`,
      showCancelButton: true,
      cancelButtonColor: 'gray',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = optionsReasonChangeBookingDate.find(item => item.value === values.reasonCode);
        const data = { ...values, claimId: item.claimId, reason: reason.label };
        updateBooking(data);
      }
    });
  }

  if (loading) {
    return <LoadingPage loading={true} />;
  }

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <Row justify="center" align="middle">
        <Col span={24} style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h2>เปลี่ยนวันเข้ารับสินค้าเคลม</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24} >
          <RenderForm
            control={control}
            forms={FORM_CHANGE_BOOKING_DATE({ warranty: item, optionsReasonChangeBookingDate, watch })}
            setValue={setValue}
            getValues={getValues}
          />
          <Col span={24} style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between' }}>
            <ButtonTheme
              useFor="CHANGE_BOOKING_DATE"
              title="ยืนยันเปลี่ยน"
              onClick={handleSubmit(onSubmitSuccess)}
              style={{ width: '40%' }}
            />
            <ButtonTheme
              useFor="CANCEL"
              title="ยกเลิก"
              onClick={onToggle}
              style={{ width: '40%' }}
            />
          </Col>
        </Col>
      </Row>
    </ModalTheme>
  );
};
